"use strict";

const React = require("react");

const noop = () => {};

const dispatcher = new Proxy(
  {},
  {
    get: () => noop,
  },
);

const DevOverlayContext = React.createContext(null);

function getSegmentTrieData() {
  return null;
}

function getSerializedOverlayState() {
  return null;
}

function renderAppDevOverlay() {}

function renderPagesDevOverlay() {}

function useDevOverlayContext() {
  return null;
}

module.exports = {
  __esModule: true,
  DevOverlayContext,
  dispatcher,
  getSegmentTrieData,
  getSerializedOverlayState,
  renderAppDevOverlay,
  renderPagesDevOverlay,
  useDevOverlayContext,
};
